// Imports
//=require lazysizes/lazysizes.min.js
//=require smooth-scroll/dist/smooth-scroll.polyfills.min.js
//=require imask/dist/imask.min.js
//=require just-validate/dist/js/just-validate.min.js
//=require tiny-slider/dist/min/tiny-slider.js

const headerOverlay = document.getElementById('site-header-overlay');
const siteNavigation = document.getElementById('site-navigation');
const menuButton = document.getElementById('navigation-menu-button');
const overlayElem = document.querySelector('.overlay');
const modalPhone = document.getElementById('modal-phone');
const floatingQuote = document.getElementById('floating-quote');
const floatingContact = document.getElementById('floating-contact');
const passToShowContact = document.querySelector('.pass-to-show-contact');
const passToShowQuote = document.querySelector('.pass-to-show-quote');
const inputsNumber = document.querySelectorAll('.only-numbers');
const inputsPhone = document.querySelectorAll('.input-phone');
const inputDate = document.querySelectorAll('.input-date');
const goToAnchorLink = document.querySelectorAll('.go-to-anchor');
const addItemButton = document.querySelector('.page-quote-form-add__button');
const forms = document.querySelectorAll('.form');
const buttonContact = document.querySelector('.floating-contact__title');
const buttonQuickQuote = document.querySelector('.floating-contact__button_quote'); 
const submenus = document.querySelectorAll('.site-navigation__sublist-wrapper');
const headerQuote = document.querySelector('.page-header-quote__form');
const otherTopicsButton = document.querySelectorAll('.kc-more-topics-topic__title');
let zipcodeInput = document.querySelectorAll('[data-validate-field$="ipcode"]');
let toggleButtonsInsurance = document.querySelectorAll('.insurances-type-toggle');
let officeTabs = document.querySelector('.office-content-tabs');
let showMoreLeadership = document.querySelectorAll('.leadership-member__show-more');
let toggleFaqs = document.querySelectorAll('.faqs-content__question button');
var insuranceSelected;
var popupTaxes = document.querySelector('.popup-taxes');
var popupTaxesOverlay = document.querySelector('.overlay-popup');

// Polyfill remove()
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if (this.parentNode !== null)
                    this.parentNode.removeChild(this);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// Restricts input for the given textbox to the given inputFilter.
function setInputFilter(textbox, inputFilter) {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    });
}

let slideUp = function(target, duration)  {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(function() {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

let slideDown = function(target, duration) {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
        display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(function() {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}
let slideToggle = function(target, duration) {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    } else {
        return slideUp(target, duration);
    }
}


function showMenu(event) {
    event.preventDefault();
    menuButton.classList.add('site-header-controls__menu-button_active');
    menuButton.classList.remove('site-header-controls__menu-button_inactive');
    siteNavigation.classList.add('site-navigation_active');
    siteNavigation.classList.remove('site-navigation_inactive');
    overlayElem.classList.add('overlay_active');
    overlayElem.classList.remove('overlay_inactive');
}

function hideMenu(event) {
    event.preventDefault();
    menuButton.classList.remove('site-header-controls__menu-button_active');
    menuButton.classList.add('site-header-controls__menu-button_inactive');
    siteNavigation.classList.remove('site-navigation_active');
    siteNavigation.classList.add('site-navigation_inactive');
    overlayElem.classList.remove('overlay_active');
    overlayElem.classList.add('overlay_inactive');
}

function activateContanct(event) {
    buttonContact.classList.toggle('floating-contact__title_active')
    floatingContact.classList.toggle('floating-contact_active');
}

function deactivateContanct(event) {
    buttonContact.classList.remove('floating-contact__title_active')
    floatingContact.classList.remove('floating-contact_active');
}

function activateQuickQuote(event) {
    floatingQuote.classList.add('floating-quote_active');
}

function deactivateQuickQuote(event) {
    buttonQuickQuote.classList.remove('floating-quote__title_active')
    floatingQuote.classList.remove('floating-quote_active');
}

function showSubmenuDesktop(event) {
    event.preventDefault();
    let target = this.nextElementSibling;
    if (target.classList.contains('site-navigation__sublist-wrapper_active')) {
        target.classList.remove('site-navigation__sublist-wrapper_active');
    } else {
        hideSubmenusDesktop();
        target.classList.add('site-navigation__sublist-wrapper_active');
    }
}

function hideSubmenusDesktop(params) {
    [].forEach.call(submenus, function (element) {
        element.classList.remove('site-navigation__sublist-wrapper_active');
    });
    
}

function showSubmenu(event) {
    event.preventDefault();
    let target = this.nextElementSibling;
    slideToggle(target, 500);


    if (this.classList.contains('site-navigation__link_has-children')) {
        this.classList.toggle('site-navigation__link_active');
    } else if (this.classList.contains('site-navigation__sublink_has-children')) {
        this.classList.toggle('site-navigation__sublink_active');
    } else if (this.classList.contains('site-footer-navigation__link_has-children')) {
        this.classList.toggle('site-footer-navigation__link_active');
    }
}
function showSubmenuInsurance(event) {
    event.preventDefault();

    const insurance = document.querySelectorAll('#site-navigation__sublist_insurance .site-navigation__subitem > a');
    Array.prototype.forEach.call (insurance, function (node) {

        node.classList.remove('site-navigation__sublink_active')
    
    } );
    
    this.classList.add('site-navigation__sublink_active');
    // if (this.classList.contains('site-navigation__sublink_has-children')) {
        
    // } 
}


function preventLink(event) {
    event.preventDefault();
}

function closePopupTaxes() {
    popupTaxes.classList.remove('popup-taxes_active');
    popupTaxes.removeAttribute('tabindex');
    popupTaxesOverlay.classList.remove('overlay-popup_active');
    popupTaxesOverlay.classList.add('overlay-popup_inactive');
}

let configuration = { attributes: true, attributeOldValue: true };

let mutationObserverSubmit = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.oldValue == 'disabled') {
            document.querySelector('input.js-validate-error-field, select.js-validate-error-field').focus();
        }
    });
});

// DOM
const MyApp = {
    popup: {
        openPopup: function () {
            popupTaxes.classList.add('popup-taxes_active');
            popupTaxes.tabIndex = -1;
            popupTaxes.focus();
            popupTaxesOverlay.classList.add('overlay-popup_active');
            popupTaxesOverlay.classList.remove('overlay-popup_inactive');
        },
        closePopup: function () {
            closePopupTaxesButton = document.querySelector('.popup-taxes__close');
            closePopupTaxesButton.addEventListener('click', closePopupTaxes);
        },
        closePopupEsc: function () {
            document.addEventListener('keydown', function escPressed(event) {
                if (event.code == 'Escape' && popupTaxes.classList.contains('popup-taxes_active')) {
                    closePopupTaxes();
                }
            });
        }
    },
    accessibility: {
        skipContent: function () {
            let skipButton = document.querySelector('#skip-content');
            skipButton.addEventListener('click', function (event) {
                event.preventDefault();
                let h1 = document.querySelector('#main h1');
                if (!h1) {
                    h1 = document.querySelector('#main h2');
                }
                h1.tabIndex = -1;
                h1.focus();
            });
        },
        keypress: function () {

            document.addEventListener('keydown', function escPressed(event) {
                if (event.code == 'Escape' && siteNavigation.classList.contains('site-navigation_active')) {
                    hideMenu(event)
                } else if (event.code == 'Escape' && document.querySelector('.floating-quote_active')) {
                    deactivateQuickQuote();
                } else if (event.code == 'Escape' && document.querySelector('.floating-contact_active')) {
                    deactivateContanct();
                } else if (event.code == 'Escape' && document.querySelector('.site-navigation__sublist-wrapper_active')) {
                    hideSubmenusDesktop();
                }
            });
        }
    },
    menu: {
        navigation: function () {
            menuButton.addEventListener('click', function toggleMenu(event) {
                if (menuButton.classList.contains('site-header-controls__menu-button_active')) {
                    hideMenu(event);
                } else {
                    showMenu(event);
                }
            });
        },
        submenu : function submenu() {
            let fatherLinks = document.querySelectorAll('.site-navigation__link_has-children, .site-navigation__sublink_has-children, .site-footer-navigation__link_has-children');

            function checkViewportForMenu(viewportWidth) {
                if (!viewportWidth.matches) {
                    [].forEach.call(fatherLinks, function (elem) {
                        elem.removeEventListener('click', preventLink);
                        elem.addEventListener('click', showSubmenu);
                        elem.removeEventListener('click', showSubmenuDesktop);
                        if (elem.classList.contains('site-footer-navigation__link_has-children') || elem.classList.contains('site-navigation__sublink_has-children')) {
                            elem.setAttribute('href', '#');
                        }
                    });
                } else {
                    [].forEach.call(fatherLinks, function (elem) {
                        elem.removeEventListener('click', showSubmenu);
                        elem.addEventListener('click', preventLink);
                        elem.addEventListener('click', showSubmenuDesktop);
                        elem.removeEventListener('click', showSubmenuInsurance);

                        if (elem.classList.contains('site-footer-navigation__link_has-children') || elem.classList.contains('site-navigation__sublink_has-children')) {
                            //elem.addAttribute('href');
                            
                            elem.removeEventListener('click', showSubmenuDesktop);
                            elem.addEventListener('click', showSubmenuInsurance);
                            const g = document.querySelector('#site-navigation__sublist_insurance .site-navigation__subitem:first-child > a');
                        }
                        if (elem.classList.contains('site-navigation__link_has-children')) {
                            const g = document.querySelector('#site-navigation__sublist_insurance .site-navigation__subitem:first-child > a');
                            g.classList.add('site-navigation__sublink_active')
                        }
                    });

                    window.addEventListener('click', function (event) {
                        if (!document.querySelector('.site-header').contains(event.target)) {
                            hideSubmenusDesktop();
                        } 
                    });
                }
            }

            let viewportWidth = window.matchMedia('(min-width: 1240px)');
            checkViewportForMenu(viewportWidth);
            viewportWidth.addListener(checkViewportForMenu);
        }
    },
    modalPhone: {
        openModalPhone: function () {
            let button = document.getElementById('call-button');
            function openModalPhone(event) {
                event.preventDefault();
                modalPhone.classList.add('modal-phone_active');
                modalPhone.classList.remove('modal-phone_inactive');
                overlayElem.classList.add('overlay_active');
                overlayElem.classList.remove('overlay_inactive');
            }
            button.addEventListener('click', openModalPhone);
        },
        closeModalPhone: function () {
            let button = document.getElementById('modal-phone-close');
            function closeModalPhone(event) {
                event.preventDefault();
                modalPhone.classList.remove('modal-phone_active');
                modalPhone.classList.add('modal-phone_inactive');
                overlayElem.classList.remove('overlay_active');
                overlayElem.classList.add('overlay_inactive');
            }
            button.addEventListener('click', closeModalPhone);
        }
    },
    onlyNumbers: function () {
        for (let counter = 0; counter < inputsNumber.length; counter++) {
            setInputFilter(inputsNumber[counter], function (value) {
                return /^[0-9]*$/.test(value);
            });
        }
    },
    onlyLetters: function () {
        let onlyletters = document.querySelectorAll('.only-letters');
        for (let counter = 0; counter < onlyletters.length; counter++) {
            setInputFilter(onlyletters[counter], function (value) {
                return /^[a-zA-ZáéíóúÁÉÍÓÚ'´ñÑäëïöüÄËÏÖÜ \-]*$/.test(value);
            });
        }
    },
    onlyAlphaNumeric: function () {
        let onlyletters = document.querySelectorAll('.only-alpha-numeric');
        for (let counter = 0; counter < onlyletters.length; counter++) {
            setInputFilter(onlyletters[counter], function (value) {
                return /^[0-9a-zA-Z]*$/.test(value);
            });
        }
    },
    onlyPhone: function () {
        let onlyPhone = document.querySelectorAll('.only-phone');
        for (let counter = 0; counter < onlyPhone.length; counter++) {
            setInputFilter(onlyPhone[counter], function (value) {
                return /^[0-9\-]*$/.test(value);
            });

           
        }
    },
    onlyDate: function () {
        let onlyDate = document.querySelectorAll('.only-date');
        for (let counter = 0; counter < onlyDate.length; counter++) {
            setInputFilter(onlyDate[counter], function (value) {
                return /^[0-9\/]*$/.test(value);
            });
        }
    },
    gotoAnchor: function () {
        let scroll = new SmoothScroll('.go-to-anchor', {
            offset: 120
        });
    },
    quote: {
        form: function () {

            new JustValidate('.form', {
                focusWrongField: true,
                rules: {
                    gender: {
                        required: true
                    },
                    firstName: {
                        required: true,
                        maxLength: 50,
                        minLength: 2
                    },
                    lastName: {
                        required: true,
                        maxLength: 50,
                        minLength: 2
                    },
                    email: {
                        required: true,
                        email: true,
                        maxLength: 120,
                    },
                    valodEmail: {
                        email: true,
                        maxLength: 120,
                    },
                    phone: {
                        required: true,
                        maxLength: 12,
                        minLength: 12
                    },
                    address: {
                        required: true,
                        maxLength: 120,
                        minLength: 2
                    },
                    'address-property': {
                        required: true,
                        maxLength: 120,
                        minLength: 2
                    },
                    insured: {
                        required: true
                    },
                    coverage: {
                        required: true
                    },
                    service: {
                        required: true
                    },
                    zipcode: {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    },
                    validZipcode: {
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    },
                    'zipcode-property': {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    },
                    state: {
                        required: true
                    },
                    status: {
                        required: true
                    },
                    buldingUnits : {
                        required: true
                    },
                    experience : {
                        required: true
                    },
                    propertyUse : {
                        required: true
                    },
                    squareFootage : {
                        required: true
                    },
                    propertyType : {
                        required: true
                    },
                    numberStories : {
                        required: true
                    },
                    numberBedrooms : {
                        required: true
                    },
                    homeownersInsurance : {
                        required: true
                    },
                    'vehicleMileage-0': {
                        function: function (name, value) {
                            if (value >= 1000 && value <= 50000) {
                                return true;
                            } else if (value == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'vehicleMileage-1': {
                        function: function (name, value) {
                            if (value >= 1000 && value <= 50000) {
                                return true;
                            } else if (value == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'vehicleMileage-2': {
                        function: function (name, value) {
                            if (value >= 1000 && value <= 50000) {
                                return true;
                            } else if (value == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'vehicleMileage-3': {
                        function: function (name, value) {
                            if (value >= 1000 && value <= 50000) {
                                return true;
                            } else if (value == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'vehicleMileage-4': {
                        function: function (name, value) {
                            if (value >= 1000 && value <= 50000) {
                                return true;
                            } else if (value == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'vehicleVin-0': {
                        minLength: 10
                    },
                    'vehicleVin-1': {
                        minLength: 10
                    },
                    'vehicleVin-2': {
                        minLength: 10
                    },
                    'vehicleVin-3': {
                        minLength: 10
                    },
                    'vehicleVin-4': {
                        minLength: 10
                    },
                    'vehicleYear-0': {
                        required: true
                    },
                    'vehicleMake-0': {
                        required: true
                    },
                    'vehicleModel-0': {
                        required: true
                    },
                    'vehicleStatus-0': {
                        required: true
                    },
                    'vehicleType-0': {
                        required: true
                    },
                    'vehicleYear-1': {
                        required: true
                    },
                    'vehicleMake-1': {
                        required: true
                    },
                    'vehicleModel-1': {
                        required: true
                    },
                    'vehicleStatus-1': {
                        required: true
                    },
                    'vehicleType-1': {
                        required: true
                    },
                    'vehicleYear-2': {
                        required: true
                    },
                    'vehicleMake-2': {
                        required: true
                    },
                    'vehicleModel-2': {
                        required: true
                    },
                    'vehicleStatus-2': {
                        required: true
                    },
                    'vehicleType-2': {
                        required: true
                    },
                    'vehicleMake-3': {
                        required: true
                    },
                    'vehicleModel-3': {
                        required: true
                    },
                    'vehicleStatus-3': {
                        required: true
                    },
                    'vehicleType-3': {
                        required: true
                    },
                    'vehicleYear-4': {
                        required: true
                    },
                    'vehicleMake-4': {
                        required: true
                    },
                    'vehicleModel-4': {
                        required: true
                    },
                    'vehicleStatus-4': {
                        required: true
                    },
                    'vehicleType-4': {
                        required: true
                    },
                    'vehicleStatus-4': {
                        required: true
                    },
                    'vehicleType-4': {
                        required: true
                    },
                    'firstName-0': {
                        required: true
                    },
                    'lastName-0': {
                        required: true
                    },
                    'birthDate-0': {
                        required: true,
                        strength: {
                            custom: '^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}'
                        },
                        function: function (name, value) {
                            currentYear = new Date().getFullYear();
                            value = currentYear - (value.substr(value.length - 4));
                            if (value >= 16  && value < 100) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'maritalStatus-0': {
                        required: true
                    },
                    'incidents-0': {
                        required: true
                    },
                    'relationship-0': {
                        required: false
                    },
                    'firstName-1': {
                        required: true
                    },
                    'lastName-1': {
                        required: true
                    },
                    'birthDate-1': {
                        required: true,
                        strength: {
                            custom: '^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}'
                        },
                        function: function (name, value) {
                            currentYear = new Date().getFullYear();
                            value = currentYear - (value.substr(value.length - 4));
                            if (value >= 16 && value < 100) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'maritalStatus-1': {
                        required: true
                    },
                    'incidents-1': {
                        required: true
                    },
                    'relationship-1': {
                        required: true
                    },
                    'firstName-2': {
                        required: true
                    },
                    'lastName-2': {
                        required: true
                    },
                    'birthDate-2': {
                        required: true,
                        strength: {
                            custom: '^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}'
                        },
                        function: function (name, value) {
                            currentYear = new Date().getFullYear();
                            value = currentYear - (value.substr(value.length - 4));
                            if (value >= 16 && value < 100) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'maritalStatus-2': {
                        required: true
                    },
                    'incidents-2': {
                        required: true
                    },
                    'relationship-2': {
                        required: true
                    },
                    'firstName-3': {
                        required: true
                    },
                    'lastName-3': {
                        required: true
                    },
                    'birthDate-3': {
                        required: true,
                        strength: {
                            custom: '^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}'
                        },
                        function: function (name, value) {
                            currentYear = new Date().getFullYear();
                            value = currentYear - (value.substr(value.length - 4));
                            if (value >= 16 && value < 100) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'maritalStatus-3': {
                        required: true
                    },
                    'incidents-3': {
                        required: true
                    },
                    'vehicleYear-3': {
                        required: true
                    },
                    'relationship-3': {
                        required: true
                    },
                    'firstName-4': {
                        required: true
                    },
                    'lastName-4': {
                        required: true
                    },
                    'birthDate-4': {
                        required: true,
                        strength: {
                            custom: '^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}'
                        },
                        function: function (name, value) {
                            currentYear = new Date().getFullYear();
                            value = currentYear - (value.substr(value.length - 4));
                            if (value >= 16 && value < 100) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    'maritalStatus-4': {
                        required: true
                    },
                    'incidents-4': {
                        required: true
                    },
                    'relationship-4': {
                        required: true
                    },
                    'vehicleModification-0': {
                        required: true
                    },
                    'vehicleModification-1': {
                        required: true
                    },
                    'vehicleModification-2': {
                        required: true
                    },
                    'vehicleModification-3': {
                        required: true
                    },
                    'vehicleModification-4': {
                        required: true
                    },
                    'businessName': {
                        required: true
                    },
                    'employeeNumber': {
                        required: true
                    },
                    'typeInsurance': {
                        function: function (name, value) {
                            checkboxes = document.querySelector('.checkboxes__input:checked');
                            if (checkboxes) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                },
                messages: {
                    validZipcode: {
                        remote: 'Please enter a valid zipcode'
                    },
                    zipcode: {
                        remote: 'Please enter a valid zipcode'
                    },
                    'zipcode-property': {
                        remote: 'Please enter a valid zipcode'
                    },
                    phone: {
                        maxLength: 'Please enter 10 digits',
                        minLength: 'Please enter 10 digits'
                    },
                    'vehicleMileage-0': {
                        function: 'Please enter a value between 1000 and 50000'
                    },
                    'vehicleMileage-1': {
                        function: 'Please enter a value between 1000 and 50000'
                    },
                    'vehicleMileage-2': {
                        function: 'Please enter a value between 1000 and 50000'
                    },
                    'vehicleMileage-3': {
                        function: 'Please enter a value between 1000 and 50000'
                    },
                    'vehicleMileage-4': {
                        function: 'Please enter a value between 1000 and 50000'
                    },
                    'birthDate-0': {
                        strength:'Verify Date of Birth',
                        function:'Verify Date of Birth'
                    },
                    'birthDate-1': {
                        strength:'Verify Date of Birth',
                        function: 'Verify Date of Birth'
                    },
                    'birthDate-2': {
                        strength:'Verify Date of Birth',
                        function: 'Verify Date of Birth'
                    },
                    'birthDate-3': {
                        strength:'Verify Date of Birth',
                        function: 'Verify Date of Birth'
                    },
                    'birthDate-4': {
                        strength:'Verify Date of Birth',
                        function: 'Verify Date of Birth'
                    },
                    'typeInsurance' : {
                        function: 'Please at least select one type of insurance'
                    }
                },
                submitHandler: function (form) {
                    form.classList.add('form_loading');
                    form.submit();
                }
            });
        },
        phone: function () {
            [].forEach.call(inputsPhone, function (element) {
                let phoneMask = new IMask(element, {
                    mask: '000-000-0000'
                });
            });
        },
        date: function () {
            let inputsDate = document.querySelectorAll('.input-date');
            [].forEach.call(inputsDate, function (element) {
                let dateMask = new IMask(element, {
                    mask: '0[0]/0[0]/0000'
                });
            });
        },
        removeErrorSelects: function () {
            let selects = document.querySelectorAll('.page-quote-form__select');
            [].forEach.call(selects, function (element) {
                element.addEventListener('change', function () {
                    if (this.classList.contains('js-validate-error-field')) {
                        this.classList.remove('js-validate-error-field');
                        this.closest('.page-quote-form__item').querySelector('.js-validate-error-label').remove();
                        this.removeAttribute('style');
                    }
                });
            });
        },
        checkSelectAsValid: function () {
            let selects = document.querySelectorAll('.page-quote-form__select');
            [].forEach.call(selects, function (element) {
                element.addEventListener('change', function () {
                    if (this.value !== '') {
                        this.closest('.page-quote-form__item').classList.add('page-quote-form__item_valid-select');
                    } else {
                        this.closest('.page-quote-form__item').classList.remove('page-quote-form__item_valid-select');
                    }
                });
            });
        },
        removeZipCodeError: function () {
            [].forEach.call(zipcodeInput, function (elem) {
                elem.addEventListener('keyup', function () {
                    if (this.classList.contains('js-validate-error-field')) {
                        this.classList.remove('js-validate-error-field');
                        this.closest('div').querySelector('.js-validate-error-label').remove();
                        this.removeAttribute('style');
                    }
                })
            });
        },
        recountItems: function () {
            let subtitles = document.querySelectorAll('.page-quote-form__subtitle');

            for (let h = 0; h < subtitles.length; h++) {
                let newSubtitle = subtitles[h].textContent.split('#')[0] + '#' + (h + 1);
                subtitles[h].textContent = newSubtitle;
            }

            let formBoxes = document.querySelectorAll('.page-quote-form__box');

            for (let c = 0; c < formBoxes.length; c++) {
                let labels = formBoxes[c].querySelectorAll('.page-quote-form__label');
                let allInputs = formBoxes[c].querySelectorAll('.page-quote-form__select, .page-quote-form__input');

                if (c > 0) {
                    formBoxes[c].classList.add('page-quote-form__box_cloned');
                }

                for (let i = 0; i < labels.length; i++) {
                    let oldLabel = labels[i].getAttribute('for');
                    let newLabel = oldLabel.substring(0, oldLabel.indexOf('-') + 1) + c;
                    let oldIds = allInputs[i].getAttribute('id');
                    let newIds = oldIds.substring(0, oldIds.indexOf('-') + 1) + c;
                    let oldNames = allInputs[i].getAttribute('name');
                    let prefixNewNames = oldNames.substring(0, oldNames.indexOf('[') + 1);
                    let sufixNewNames = oldNames.substring(oldNames.indexOf(']'));
                    let newNames = prefixNewNames + c + sufixNewNames;
                    labels[i].setAttribute('for', newLabel);
                    allInputs[i].setAttribute('id', newIds);
                    allInputs[i].setAttribute('name', newNames);
                }

                let dataValidations = formBoxes[c].querySelectorAll('[data-validate-field]');

                for (let d = 0; d < dataValidations.length; d++) {
                    let dataValidationsValue = dataValidations[d].getAttribute('data-validate-field');
                    let newDataValidationsValue = dataValidationsValue.substring(0, dataValidationsValue.indexOf('-') + 1) + c;
                    dataValidations[d].setAttribute('data-validate-field', newDataValidationsValue);
                }
            }


            MyApp.onlyNumbers();
            MyApp.onlyLetters();
            MyApp.onlyPhone();
            MyApp.onlyDate();
            MyApp.quote.countFormBoxes();
            MyApp.quote.confirmation();
            MyApp.quote.deleteItemYes();
            MyApp.quote.deleteItemNo();
            MyApp.quote.date();
            MyApp.quote.removeErrorSelects();
        },
        cloneItems: function () {
            let container = document.getElementById('page-quote-form-container');

            addItemButton.addEventListener('click', function (event) {
                event.preventDefault();
                let toClone = document.querySelector('.page-quote-form__box');
                let clonedItem = toClone.cloneNode(true);

                clonedItem.classList.add('page-quote-form__box_cloned');
                container.appendChild(clonedItem);

                let labelsError = clonedItem.querySelectorAll('.js-validate-error-label');
                let inputs = clonedItem.querySelectorAll('.page-quote-form__input, .page-quote-form__select');

                for (let n = 0; n < inputs.length; n++) {
                    inputs[n].value = '';
                    inputs[n].classList.remove('js-validate-error-field');
                    inputs[n].removeAttribute('style');
                }

                for (let m = 0; m < labelsError.length; m++) {
                    labelsError[m].remove();
                }
                MyApp.quote.recountItems();
                clonedItem.querySelector('input, select').focus();
            });
        },
        countFormBoxes: function () {
            let formBoxesToCount = document.querySelectorAll('.page-quote-form__box');
            let addButtonContainer = document.querySelector('.page-quote-form-add');
            if (formBoxesToCount.length > 4) {
                addButtonContainer.classList.add('page-quote-form-add_hide');
            } else if (formBoxesToCount.length !== 5) {
                addButtonContainer.classList.remove('page-quote-form-add_hide');
            }
        },
        confirmation: function () {
            let deleteButton = document.querySelectorAll('.page-quote-form-delete');

            function showConfirmationToDelete(event) {
                event.preventDefault();
                this.closest('.page-quote-form__box').querySelector('.page-quote-form-confirmation').classList.add('page-quote-form-confirmation_active');
                this.closest('.page-quote-form__box').querySelector('.page-quote-form-confirmation__control_no').focus();
            }

            for (let z = 0; z < deleteButton.length; z++) {
                deleteButton[z].addEventListener('click', showConfirmationToDelete);
            }
        },
        deleteItemYes: function () {
            let buttonyes = document.querySelectorAll('.page-quote-form-confirmation__control_yes');

            function deleteItem(event) {
                event.preventDefault();
                this.closest('.page-quote-form__box').remove();
                MyApp.quote.countFormBoxes();
                MyApp.quote.recountItems();
                addItemButton.focus();
            }

            for (let x = 0; x < buttonyes.length; x++) {
                buttonyes[x].addEventListener('click', deleteItem);
            }
        },
        deleteItemNo: function () {
            let buttonNo = document.querySelectorAll('.page-quote-form-confirmation__control_no');

            function dontDeleteItem(event) {
                event.preventDefault();
                this.closest('.page-quote-form__box').querySelector('.page-quote-form-confirmation').classList.remove('page-quote-form-confirmation_active');
                this.closest('.page-quote-form__box').querySelector('input:invalid, select:invalid').focus();
            }

            for (let y = 0; y < buttonNo.length; y++) {
                buttonNo[y].addEventListener('click', dontDeleteItem);
            }
        }/* ,
        contact : function () {
            let contactRadios = document.querySelectorAll('[name="contact"]');

            contactRadios.forEach(radio => {
                radio.addEventListener('change', ()=>{
                    if (radio.value === 'email')
                });
            });
        } */
    },
    home: {
        quote: function () {

            new JustValidate('.quote-home-form ', {
                rules: {
                    type: {
                        required: true
                    },
                    zipcode: {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    }
                },
                messages: {
                    zipcode: {
                        remote: 'Please enter a valid zipcode'
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('quote-home-form_loading');
                    form.submit();
                }
            });

            // Select the node that will be observed for mutations
            //let targetNode = document.querySelector('.quote-home-form__submit');

            // Start observing the target node for configured mutations
            //mutationObserverSubmit.observe(targetNode, configuration);
        },
        chooseProduct: function () {
            let productButtons = document.querySelectorAll('.quote-home-products__product');
            let productsIcons = document.querySelectorAll('.quote-home-form__selection');
            let quoteHomeForm = document.querySelector('.quote-home-form');
            let backToChooseProduct = document.querySelector('.quote-home-form__back');
            let productsList = document.querySelector('.quote-home-products__list');
            let homeForm = document.querySelector('.quote-home-form');

            [].forEach.call(productButtons, function (elem) {
                elem.addEventListener('click', function (event) {
                    [].forEach.call(productsIcons, function (elem) {
                        elem.classList.remove('quote-home-form__selection_selected');
                    });
                    insuranceSelected = this.dataset.insurance;
                    insuranceSelectedUrl = this.dataset.insuranceUrl;
                    document.querySelector('.quote-home-form__selection[data-insurance=' + insuranceSelected + ']').classList.add('quote-home-form__selection_selected');
                    homeForm.action = insuranceSelectedUrl;
                    quoteHomeForm.classList.remove('quote-home-form_inactive');
                    quoteHomeForm.classList.add('quote-home-form_active');
                    productsList.classList.add('quote-home-products__list_inactive');
                    productsList.classList.remove('quote-home-products__list_active');
                    setTimeout(function () {
                        document.querySelector('.quote-home-form__zipcode').focus();
                    }, 500);
                    
                });
            });

            backToChooseProduct.addEventListener('click', function (event) {
                quoteHomeForm.classList.remove('quote-home-form_active');
                quoteHomeForm.classList.add('quote-home-form_inactive');
                productsList.classList.add('quote-home-products__list_active');
                productsList.classList.remove('quote-home-products__list_inactive');
                setTimeout(function () {
                    document.querySelector('.quote-home-products__product[data-insurance='+insuranceSelected+']').focus();
                }, 500);
            });

        },
        aboutSlider: function () {
            let slider = tns({
                container: '.about-home-slider__list',
                items: 1,
                autoHeight: true,
                preventScrollOnTouch: 'auto',
                controls: false,
                loop: false,
                lazyload: true,
                responsive: {
                    640: {
                        edgePadding: 20,
                        gutter: 20,
                        items: 2
                    },
                    700: {
                        gutter: 30
                    },
                    1040: {
                        items: 4,
                        gutter: 70
                    }
                }
            });
        },
        reviewsSlider: function () {
            let prev = document.querySelector('.reviews-home-slider').dataset.iconPrev;
            let next = document.querySelector('.reviews-home-slider').dataset.iconNext;
            let slider = tns({
                container: '.reviews-home__list',
                items: 1,
                autoHeight: true,
                preventScrollOnTouch: 'auto',
                responsive: {
                    830: {
                        controlsText: ["<span class='visually-hidden'>Previous review</span><span class='icon' title='Previous review'><svg><use xlink:href="+prev+"></use></svg></span>", "<span class='visually-hidden'>Next review</span><span class='icon' title='Next review'><svg><use xlink:href="+next+"></use></svg></span>"]
                    }
                    
                }
            });
        }
    },
    floatingContact : {
        showContact: function () {
            let viewportWidth = window.matchMedia('(min-width: 1240px)');

            function checkMarkForContact() {
                let bounding = passToShowContact.getBoundingClientRect();
                let atBottom = (window.pageYOffset + window.innerHeight);
                let height = document.documentElement.scrollHeight - 60;
                if (atBottom > height) {
                    floatingContact.classList.remove('floating-contact_show');
                } else if ((bounding.height - 100 + bounding.top) <= 0) {
                    floatingContact.classList.add('floating-contact_show');
                } else {
                    floatingContact.classList.remove('floating-contact_show');
                }
            }

            function checkViewportForContact(viewportWidth) {
                if (!viewportWidth.matches) {
                    document.addEventListener('scroll', checkMarkForContact);
                    buttonContact.addEventListener('click', activateContanct);
                    
                } else {
                    document.removeEventListener('scroll', checkMarkForContact);
                    buttonContact.removeEventListener('click', activateContanct);
                }
            }
            
            checkViewportForContact(viewportWidth);
            viewportWidth.addListener(checkViewportForContact);
        }
    },
    floatingQuote: {
        showQuote: function () {
            let viewportWidth = window.matchMedia('(min-width: 1240px)');
            let quickQuoteClose = document.querySelector('.floating-quote__title');

            function checkMarkForQuote() {
                let bounding = passToShowContact.getBoundingClientRect();
                let atBottom = (window.pageYOffset + window.innerHeight);
                let height = document.documentElement.scrollHeight - 60;
                if (atBottom > height) {
                    floatingQuote.classList.remove('floating-quote_show');
                } else if ((bounding.height - 100 + bounding.top) <= 0) {
                    floatingQuote.classList.add('floating-quote_show');
                } else {
                    floatingQuote.classList.remove('floating-quote_show');
                }
            }

            function checkViewportForContact(viewportWidth) {
                if (!viewportWidth.matches) {
                    document.removeEventListener('scroll', checkMarkForQuote);
                    buttonQuickQuote.addEventListener('click', activateQuickQuote);
                    quickQuoteClose.addEventListener('click', deactivateQuickQuote);

                } else {
                    document.addEventListener('scroll', checkMarkForQuote);
                    buttonQuickQuote.removeEventListener('click', activateQuickQuote);
                    quickQuoteClose.removeEventListener('click', deactivateQuickQuote);
                }
            }

            checkViewportForContact(viewportWidth);
            viewportWidth.addListener(checkViewportForContact);

        },
        form: function () {

            new JustValidate('.floating-quote__form', {
                rules: {
                    type: {
                        required: true
                    },
                    zipcode: {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    }
                },
                messages: {
                    zipcode: {
                        remote: 'Please enter a valid zipcode'
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('floating-quote__form_loading');
                    form.submit();
                }
            });

            // Select the node that will be observed for mutations
            //let targetNode = document.querySelector('.floating-quote__submit');

            // Start observing the target node for configured mutations
            //mutationObserverSubmit.observe(targetNode, config);
        }
    },
    products : {
        form: function () {

            new JustValidate('.page-header-quote__form', {
                rules: {
                    zipcode: {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    }
                },
                messages: {
                    zipcode: {
                        remote: 'Please enter a valid zipcode'
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('page-header-quote__form_loading');
                    form.submit();
                }
            });
        },
        quote: function () {

            new JustValidate('#quoteWidget1', {
                rules: {
                    zipcode: {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    }
                },
                messages: {
                    zipcode: {
                        remote: 'Please enter a valid zipcode'
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('c-quote-widget__form--loading');
                    form.submit();
                }
            });
        },
        quote2: function () {

            new JustValidate('#quoteWidget2', {
                rules: {
                    zipcode: {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    }
                },
                messages: {
                    zipcode: {
                        remote: 'Please enter a valid zipcode'
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('c-quote-widget__form--loading');
                    form.submit();
                }
            });
        },
        office: function () {
            new JustValidate('#officeWidget', {
                rules: {
                    address: {
                        required: true,
                    }
                },
                messages: {
                    address: {
                        remote: 'Please enter a valid zipcode'
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.submit();
                }
            });
        }
    },
    knowledgeCenter : {
        otherTopics : function () {

            function toggleOtherTopics() {
                this.classList.toggle('kc-more-topics-topic__title_active');
                slideToggle(this.nextElementSibling, 500);
            }

            [].forEach.call(otherTopicsButton, function (elem) {
                elem.addEventListener('click', toggleOtherTopics);
            });
        }
    },
    allInsurances : {
        showToggle: function () {

            [].forEach.call(toggleButtonsInsurance, function (elem) {
                elem.addEventListener('click', function () {
                    let target = this.closest('.insurances-type__title').nextElementSibling;
                    if (this.classList.contains('insurances-type-toggle_inactive')) {
                        this.classList.remove('insurances-type-toggle_inactive');
                        this.classList.add('insurances-type-toggle_active');
                        elem.querySelector('.visually-hidden').innerHTML='Show More';
                        slideUp(target, 500);
                    } else if (this.classList.contains('insurances-type-toggle_active')) {
                        this.classList.add('insurances-type-toggle_inactive');
                        this.classList.remove('insurances-type-toggle_active');
                        elem.querySelector('.visually-hidden').innerHTML = 'Show Less';
                        slideDown(target, 500);
                    }
                })
            });
        }
    },
    office : {
        tabs : function () {
            let officeTabControl = document.querySelectorAll('.office-content-tabs__control');
            let locatorTabContent = document.querySelectorAll('.office-content-tabs__content');

            function showTab() {
                [].forEach.call(officeTabControl, function (elem) {
                    elem.classList.remove('office-content-tabs__control_active');
                });
                [].forEach.call(locatorTabContent, function (elem) {
                    elem.classList.remove('office-content-tabs__content_active');
                });
                this.classList.add('office-content-tabs__control_active');
                this.closest('.office-content-tabs__tab').querySelector('.office-content-tabs__content').classList.add('office-content-tabs__content_active')
            }

            [].forEach.call(officeTabControl, function (elem) {
                elem.addEventListener('click', showTab);
            });
        },
        locatorTabs : function () {
            let locatorTabControl = document.querySelectorAll('.locator-options__option');
            let locatorTabContent = document.querySelectorAll('.locator-options__box');

            function showLocatorTab() {
                [].forEach.call(locatorTabControl, function (elem) {
                    elem.classList.remove('locator-options__option_active');
                });
                [].forEach.call(locatorTabContent, function (elem) {
                    elem.classList.remove('locator-options__box_active');
                });
                this.classList.add('locator-options__option_active');
                target = document.querySelector('#'+this.dataset.target);
                target.classList.add('locator-options__box_active')
            }

            [].forEach.call(locatorTabControl, function (elem) {
                elem.addEventListener('click', showLocatorTab);
            });
        },
        locatorHomeForm : function () {
            new JustValidate('.locator-form__form1', {
                rules: {
                    zipcode: {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    }
                },
                messages: {
                    zipcode: {
                        remote: 'Please enter a valid zipcode'
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('locator-form_form_loading');
                    form.submit();
                }
            });

            new JustValidate('.locator-form__form2', {
                rules: {
                    state: {
                        required: true
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('locator-form_form_loading');
                    form.submit();
                }
            });
        },
        locatorForm : function () {
            new JustValidate('.office-locator-form__form', {
                rules: {
                    zipcode: {
                        required: true,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            successAnswer: '1',
                            sendParam: 'zipcode',
                            method: 'GET'
                        }
                    }
                },
                messages: {
                    zipcode: {
                        remote: 'Please enter a valid zipcode'
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('office-locator-form__form_loading');
                    form.submit();
                }
            });
        },
        directionsForm : function () {
            new JustValidate('.office-directions__form', {
                rules: {
                    from: {
                        required: true
                    }
                },
                focusWrongField: true,
                submitHandler: function (form) {
                    form.classList.add('office-directions__form_loading');
                    form.submit();
                }
            });
        }
    },
    leadership : {
        showMore: function () {
            function showMoreInfo() {
                let finalHeight = this.closest('.leadership-member').querySelector('.leadership-member__text-wrapper').offsetHeight;
                let target = this.closest('.leadership-member').querySelector('.leadership-member__text');

                if (this.classList.contains('leadership-member__show-more_active')) {
                    target.style.maxHeight = '';
                    this.classList.remove('leadership-member__show-more_active');
                    this.innerHTML = 'Read More';
                } else {
                    this.classList.add('leadership-member__show-more_active');
                    target.style.maxHeight = finalHeight + 'px';
                    this.innerHTML = 'Read Less';
                }
                
            }

            [].forEach.call(showMoreLeadership, function (elem) {
                elem.addEventListener('click', showMoreInfo);
            });
        }
    },
    faqs: {
        toggleContent: function () {
            function toggleAnswer() {
                let target = this.closest('.faqs-content__item').querySelector('.faqs-content__answer');
                this.closest('.faqs-content__question').classList.toggle('faqs-content__question_active');
                slideToggle(target, 500);
                if (this.getAttribute('aria-expanded') == 'true') {
                    this.setAttribute('aria-expanded', 'false');
                } else {
                    this.setAttribute('aria-expanded', 'true');
                }
            }

            [].forEach.call(toggleFaqs, function (elem) {
                elem.addEventListener('click', toggleAnswer);
            });
        }
    },
    buttons: {
        type: function () {
            let typeSelect = document.querySelector('#type');
            let urlBox = document.querySelector('.button-generator-content__url');
            let raterBox = document.querySelector('.button-generator-content__rater');
            let phoneBox = document.querySelector('.button-generator-content__phone');
            typeSelect.addEventListener('change', function () {
                if (this.value == 'url') {
                    urlBox.classList.remove('button-generator-content__url_inactive');
                    urlBox.classList.add('button-generator-content__url_active');
                    raterBox.classList.remove('button-generator-content__rater_active');
                    raterBox.classList.add('button-generator-content__rater_inactive');
                    phoneBox.classList.remove('button-generator-content__phone_active');
                    phoneBox.classList.add('button-generator-content__phone_inactive');
                } else if (this.value == 'rater') {
                    raterBox.classList.remove('button-generator-content__rater_inactive');
                    raterBox.classList.add('button-generator-content__rater_active');
                    urlBox.classList.remove('button-generator-content__url_active');
                    urlBox.classList.add('button-generator-content__url_inactive');
                    phoneBox.classList.remove('button-generator-content__phone_active');
                    phoneBox.classList.add('button-generator-content__phone_inactive');
                } else if (this.value == 'phone') {
                    phoneBox.classList.add('button-generator-content__phone_active');
                    phoneBox.classList.remove('button-generator-content__phone_inactive');
                    raterBox.classList.remove('button-generator-content__rater_active');
                    raterBox.classList.add('button-generator-content__rater_inactive');
                    urlBox.classList.remove('button-generator-content__url_active');
                    urlBox.classList.add('button-generator-content__url_inactive');
                }
            })
        }
    }
}

// On ready

document.addEventListener('DOMContentLoaded', function (event) {

    if (popupTaxes) {
        MyApp.popup.openPopup();
        MyApp.popup.closePopup();
        MyApp.popup.closePopupEsc();
    }

    MyApp.menu.navigation();
    MyApp.menu.submenu();
    MyApp.accessibility.keypress();
    MyApp.accessibility.skipContent();
    //MyApp.modalPhone.openModalPhone();
    //MyApp.modalPhone.closeModalPhone();

    if (document.querySelector('.quote-home-form')) {
        MyApp.home.quote();
        MyApp.home.chooseProduct();
    }
/*     if (document.querySelector('.c-contact')) {
        MyApp.quote.contact();
    }
 */
    if (document.querySelector('.office-locator-form__form')) {
        MyApp.office.locatorForm();
    }

    if (document.querySelector('.locator-form__form')) {
        MyApp.office.locatorHomeForm();
    }

    if (document.querySelector('.office-directions__form')) {
        MyApp.office.directionsForm();
    }
    if (document.querySelector('.locator-options__option')) {
        MyApp.office.locatorTabs();
    }

    if (floatingContact) {
        MyApp.floatingContact.showContact();
    }

    if (floatingQuote) {
        MyApp.floatingQuote.form();
        MyApp.floatingQuote.showQuote();
    }

    if (headerQuote) {
        MyApp.products.form();
    }

    if (document.querySelector('#quoteWidget1')) {
        MyApp.products.quote();
    }

    if (document.querySelector('#quoteWidget2')) {
        MyApp.products.quote2();
    }

    if (document.querySelector('#officeWidget')) {
        MyApp.products.office();
    }

    if (inputsPhone.length) {
        MyApp.quote.phone();
    }

    if (inputDate) {
        MyApp.quote.date();
    }

    if (inputsNumber) {
        MyApp.onlyNumbers();
    }

    if (otherTopicsButton) {
        MyApp.knowledgeCenter.otherTopics();
    }

    if (officeTabs) {
        MyApp.office.tabs();
    }

    if (forms.length) {
        MyApp.quote.form();
        MyApp.quote.removeErrorSelects();
        MyApp.quote.checkSelectAsValid();
        MyApp.onlyNumbers();
        MyApp.onlyLetters();
        MyApp.onlyPhone();
        MyApp.onlyDate();
        MyApp.onlyAlphaNumeric();
    }

    if (zipcodeInput.length) {
        MyApp.quote.removeZipCodeError();
    }

    if (goToAnchorLink.length) {
        MyApp.gotoAnchor();
    }

    if (addItemButton) {
        MyApp.quote.recountItems();
        MyApp.quote.confirmation();
        MyApp.quote.deleteItemYes();
        MyApp.quote.deleteItemNo();
        MyApp.quote.cloneItems();
    }

    if (toggleButtonsInsurance.length) {
        MyApp.allInsurances.showToggle();
    }

    if (showMoreLeadership.length) {
        MyApp.leadership.showMore();
    }

    if (toggleFaqs.length) {
        MyApp.faqs.toggleContent();
    }

    if (document.querySelector('.button-generator-content')) {
        MyApp.buttons.type();
        MyApp.onlyPhone();
    }
});

window.addEventListener('load', function (event) {
    if (document.querySelector('.about-home-slider__list')) {
        MyApp.home.aboutSlider();
    }
    if (document.querySelector('.reviews-home__list')) {
        MyApp.home.reviewsSlider();
    }    

    var url = window.location.href;
    var index = url.indexOf("#");
    if (index !== -1) {
        var hash = url.substring(index + 1);
        
        var element = document.getElementById(hash);
        var headerHeight = document.querySelector('.site-header').clientHeight;
        var elementPosition = element.offsetTop;
        var offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
});

window.addEventListener('pageshow', function () {

    let loadingForm = document.querySelectorAll('.page-header-quote__form_loading');

    if (loadingForm.length) {
        [].forEach.call(loadingForm, function (element) {
            element.classList.remove('page-header-quote__form_loading')
        });
    }
});
document.addEventListener('DOMContentLoaded', function() {
    var buttons = document.querySelectorAll('.js-regional-city-button');

    buttons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            let parent = this.closest('.regular-button__container').previousElementSibling;
            let hiddens = parent.querySelectorAll('.city-hidden');
            hiddens.forEach((link, index ) => {
                    link.classList.remove('city-hidden');
                    if (index === 0) {
                        link.focus();
                    }
                }
            );
            this.style.display = 'none';
        }, { once: true });
    });
});
const replaceHypens = {
    treeWalker: document.createTreeWalker(
        document.body,
        NodeFilter.SHOW_TEXT,
        null,
        false
    ),
    searchAndReplace () {
        while (this.treeWalker.nextNode()) {
            this.treeWalker.currentNode.textContent = this.treeWalker.currentNode.textContent.replaceAll(/-|–/g, '‑');
        }
    }
}

replaceHypens.searchAndReplace();
class searchBar {
    constructor(form) {
        this.form = form;
        this.input = this.form.querySelector('.kc-page__input');
        this.submit = this.form.querySelector('.kc-page__submit');
        this.checkValue = this.checkValue.bind(this);
        this.submit.addEventListener('click', this.checkValue);
    }
    checkValue(event) {
        if (this.input.value.trim() !== '') return ;
        event.preventDefault();
    }
}

document.querySelectorAll('.kc-page__search').forEach(form => {
    new searchBar(form);
});

class OsanoTrigger {
    constructor(trigger) {
        this.trigger = trigger;
        this.trigger.addEventListener('click', this.openModal)
    }

    openModal(event) {
        event.preventDefault();
        Osano.cm.showDoNotSell();
        const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
        closeButtonDialog?.focus();
    }
};

window.addEventListener('load', () => {
    document.querySelectorAll('.js-osano-trigger').forEach(link => new OsanoTrigger(link));
});